import React, { Component, createRef } from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { PhoneOutlined, CodeOutlined, LockOutlined } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import { getCaptcha, getSMSCode, submit } from "@api/login";
import url from "@utils/url";
import bus from "@utils/bus";

const { HOST } = url;
const FormItem = Form.Item;

class NormalLoginForm extends Component {
    formRef = createRef();

    state = {
        isRedirect: false,
        captchaImgUrl: "",
        captchaId: "",
        smsCodeBtnDisbaled: false,
        count: 60,
        smsCode: ""
    };

    componentDidMount() {
        this.getCaptcha();
    }

    handleSubmit = async () => {
        try {
            const values = await this.formRef.current.validateFields();
            
            if (this.state.smsCode.length === 0) {
                message.error("请填写短信验证码");
                return;
            }

            const params = {
                mobile: values.mobile,
                smsCode: this.state.smsCode
            };
            const res = await submit(params);
            console.log(res);
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }
            bus.me = res.data;
            bus.userInfo = res.data.data && res.data.data.accountInfo;
            this.setState({ isRedirect: true });
        } catch (err) {
            console.log(err);
        }
    };

    getCaptcha() {
        getCaptcha().then(res => {
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }
            this.setState({
                captchaImgUrl: `${HOST}/cps-gateway/api/v1/admin/captcha/img/${
                    res.data.data.captcha
                }.png`,
                captchaId: res.data.data.captcha
            });
        });
    }

    changeCaptchaImg = () => {
        this.getCaptcha();
    };

    getSMSCode = async (e) => {
        e.preventDefault();
        try {
            const values = await this.formRef.current.validateFields();
            this.runGetSMSCodeCountDown();

            const params = Object.assign(values, {
                captchaId: this.state.captchaId
            });

            const res = await getSMSCode(params);
            if (res.data.meta.errCode !== 0) {
                message.error(res.data.meta.errMsg);
                return;
            }
            message.success("获取验证码成功");
        } catch (err) {
            console.log(err);
        }
    };

    runGetSMSCodeCountDown = () => {
        let count = this.state.count;

        this.setState({
            smsCodeBtnDisbaled: true
        });
        this.interval = setInterval(() => {
            count -= 1;
            this.setState({ count: count });
            if (count === 0) {
                clearInterval(this.interval);
                this.setState({
                    smsCodeBtnDisbaled: false,
                    count: 60
                });
                this.changeCaptchaImg();
            }
        }, 1000);
    };

    handleSMSCodeInputChange = e => {
        e.preventDefault();
        this.setState({
            smsCode: e.target.value
        });
    };

    render() {
        if (this.state.isRedirect) {
            return <Redirect to={"/cps/index"} />;
        }

        return (
            <div className="login">
                <div className="login_title">渠道商户后台</div>
                <div className="login_box">
                    <Form ref={this.formRef} onFinish={this.handleSubmit} className="login-form">
                        <FormItem
                            name="mobile"
                            rules={[
                                {
                                    required: true,
                                    message: "请填入手机号码"
                                }
                            ]}
                        >
                            <Input
                                size="large"
                                prefix={
                                    <PhoneOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                                }
                                placeholder="请填入手机号"
                            />
                        </FormItem>
                        <FormItem>
                            <Row>
                                <Col span={15}>
                                    <FormItem
                                        name="captcha"
                                        noStyle
                                        rules={[
                                            {
                                                required: true,
                                                message: "请填入图片验证码"
                                            }
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            prefix={
                                                <CodeOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                                            }
                                            placeholder="图片验证码"
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={9}>
                                    <div 
                                        className="captcha-img"
                                        onClick={this.changeCaptchaImg}>
                                            <img
                                                src={this.state.captchaImgUrl}
                                                alt="图片验证码img"        
                                            />
                                    </div>
                                </Col>
                            </Row>
                        </FormItem>
                        <FormItem>
                            <Row>
                                <Col span={15}>
                                    <Input
                                        onChange={this.handleSMSCodeInputChange}
                                        size="large"
                                        prefix={
                                            <LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                                        }
                                        placeholder="请填入短信验证码"
                                    />
                                </Col>
                                <Col span={9}>
                                    <Button
                                        disabled={this.state.smsCodeBtnDisbaled}
                                        className="sms_code_btn"
                                        type="primary"
                                        size="large"
                                        onClick={this.getSMSCode}
                                    >
                                        {this.state.smsCodeBtnDisbaled
                                            ? `${this.state.count} S后重发`
                                            : "获取验证码"}
                                    </Button>
                                </Col>
                            </Row>
                        </FormItem>
                        <FormItem>
                            <Button
                                size="large"
                                type="primary"
                                htmlType="submit"
                                className="login-form-button"
                            >
                                登录
                            </Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
        );
    }
}

export default NormalLoginForm;
